import $ from 'jquery';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-search-dropdown]';
const PLUGIN_NAME = 'SearchDropdown';

import SearchDropdown from './search-dropdown';

plugin(PLUGIN_NAME, SearchDropdown);

$(() => {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/search/dropdown/index.js